import styled from 'styled-components';

export const StyledTitle = styled.h1`
    font-weight: 600;
    font-size: 22px;
    line-height: 27px;
    text-align: center;
    margin-bottom: 34px;
`;
